
const initialState = () => ({
    data: [],
    autoApply: {},
});

const priceCoupons = {
    strict: true,
    namespaced: true,
    // If we use a plain object to declare the state of the module, that state object will be shared by reference 
    // and cause cross store/module state pollution when it's mutated.
    // This is actually the exact same problem with data inside Vue components. 
    // So the solution is also the same - use a function for declaring module state (supported in 2.3.0+):
    // https://vuex.vuejs.org/guide/modules.html#module-reuse
    state: initialState,
    mutations: {
        setData(state, payload) { 
            state.data = payload;
        },
        setAutoApply(state, payload) { 
            //console.log('price coupons, setAutoApply', payload)
            state.autoApply = payload;
        },
        reset(state){
          // acquire initial state
          const s = initialState()
          Object.keys(s).forEach(key => {
            state[key] = s[key]
          });
        }        
    },
    
    actions: {
        // state, commit, dispatch, rootState, rootGetters
        setData(context, payload, dispatch, rootState, rootGetters) {
            context.commit('setData', payload);
        },
        setAutoApply(context, payload, dispatch, rootState, rootGetters) {
            context.commit('setAutoApply', payload);
        },
        reset(context){
            context.commit('reset');
        }
    },
    getters: {
        data: state => state.data,
        getCoupon: state => (id, groupId) => {
            return state.data.find(coupon => coupon.couponId === id && coupon.groupId === groupId)
        },
        getAutoApply: state => (groupId) => {
            return state.autoApply.hasOwnProperty(groupId) ? state.autoApply[groupId] : null
        },
    },
};

export default priceCoupons;
